<div class="container-fluid content-page-container">
  <div class="row" >
    <div class="col-md-auto" align="left" style="display: inline-block;">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <img src='../assets/mattchandlerprofile.png' style="border-radius:10px;">
              <h4><b>Matt Chandler</b></h4>Fayetteville, Arkansas
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <a href="https://twitter.com/mattchandlerus" target="_blank" class="fab fa-twitter"></a>&nbsp;
              <a href="https://www.linkedin.com/in/mattchandlerus" target="_blank" class="fab fa-linkedin"></a>&nbsp;
              <a href="https://www.github.com/goability" target="_blank" class="fab fa-github"></a>
          </div>
          </div>
        </div>
    </div>
    <div class="col-sm-8" align="left" style="display: inline-block;">
      <ul class="list-group">
        <li class="list-group-item">Software Architect and Engineer</li>
        <li class="list-group-item">20 years experience</li>
        <li class="list-group-item">Technical and Project Lead</li>
        <li class="list-group-item">AWS Certified</li>
        <li class="list-group-item">Real world Full Stack experience</li>
        <li class="list-group-item">Small Business owner, Entrepreneur, Creator</li>
        <li class="list-group-item" style="text-align: left;">
            <a routerLink="/resume"  class="btn btn-primary btn-xs">
              <span class="glyphicon glyphicon-th"> Resume</span>
            </a>&nbsp;&nbsp;
            <a routerLink="/about"  class="btn btn-primary btn-xs">
              <span class="glyphicon glyphicon-th"> About me</span>
            </a>
        </li>

      </ul>
    </div>
  </div>
</div>
